import Modal from "components/Modal/Modal";
import { selectState, setSingleModal } from "../outputSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import { IOutputItem } from "Dashboard/scenes/Stock/domain/IOutputItem";

interface IProps {
  onSubmitSingle: (item: IOutputItem, quantityAmount: number) => void; // Expect two arguments
  setClickOutsideActive: React.Dispatch<React.SetStateAction<boolean>>;
}

const ReturnSingleItemModal = ({
  onSubmitSingle,
  setClickOutsideActive,
}: IProps) => {
  const { singleModal } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setSingleModal({ isOpen: false }));
    setClickOutsideActive(true);
  };

  const handleSubmitClick = () => {
    if (singleModal.item && singleModal.quantityAmount) {
      onSubmitSingle(singleModal.item, singleModal.quantityAmount);
    }
    close();
  };

  return (
    <Modal
      onClick={handleSubmitClick}
      onClose={close}
      isOpen={singleModal.isOpen}
    >
      <p className="info-msg">
        <b>Pažnja! Ova operacije ne može se vratiti nazad. <br /> Ona vraća
          količinu na stanje lagera i popravlja selektovanu otpremnicu i
          trebovanje.</b>
      </p>
    </Modal>
  );
};

export default ReturnSingleItemModal;
